import * as types from '../../mutationTypes';

export default {
  [types.RESET_ACTIVATED_CEMODULES](state) {
    // eslint-disable-next-line no-param-reassign
    state.activatedCEModules = [];
  },

  [types.BULK_ADD_ACTIVATED_CEMODULES](state, activatedCEModules) {
    // eslint-disable-next-line no-param-reassign
    state.activatedCEModules = activatedCEModules;
  },

  [types.UPDATE_ONE_ACTIVATED_CEMODULES](state, params) {
    const { moduleId, hasUnpublishedDraftContent } = params;
    const index = state.activatedCEModules.findIndex(({ id }) => id === parseInt(moduleId, 10));
    const copiedModule = {
      ...state.activatedCEModules[index]
    };
    state.activatedCEModules.splice(index, 1, {
      ...copiedModule,
      hasUnpublishedDraftContent
    });
  }
};
